import createWhitelistFilter from "redux-persist-transform-filter";
import {
  FETCH_CUSTODIAN_DETAILS,
  FETCH_CUSTODIAN_DETAILS_SUCCESS,
  FETCH_CUSTODIAN_DETAILS_HISTORY_SUCCESS,
  FETCH_CUSTODIAN_DETAILS_ERROR,
  RESET_CUSTODIAN_DETAILS,
  UPDATE_CUSTODIAN_DETAILS,
  DELETE_CUSTODIAN_HISTORY,
  UPDATE_CUSTODIAN_HISTORY,
  REFRESH_CUSTODIAN_HISTORY,
  UPDATE_CUSTODIAN_CASHFLOW,
  DELETE_CUSTODIAN_CASHFLOW,
  ADD_PENDING_IRR_REQUEST,
  REMOVE_PENDING_IRR_REQUEST,
  SET_INNER_DETAILS_STATE,
  SET_CURRENT_STATE,
  UPDATE_FUND_SCHEDULE,
  DELETE_FUND_SCHEDULE,
  custodianTaxTypes,
  UPDATE_CUSTODIAN_BULK,
  DELETE_HOLDING_BULK,
  INSERT_HOLDING_BULK,
  GET_CUSTODIAN_CHART,
  GET_CUSTODIAN_CHART_SUCCESS,
  GET_CUSTODIAN_CHART_ERROR,
  isCostBasisIrrTypeWithoutCost
} from "../actions/Common";
import { custodianSelector, pickProperties } from "./Common";

const initialState = {
  details: null,
  fetchDetailsPending: false,
  fetchDetailsError: false,
  pendingIrrRequests: [],
  previousState: null,
  scrollTop: 0,
  custodianChart: null,
  fetchCustodianChartPending: false,
  fetchCustodianChartError: null,
  linkedSiblingDetails: null
};

export const getNewInitialState = () => {
  return window.kbStructuredClone(initialState);
};

export const custodianDetailsPersistTransform = () => {
  return createWhitelistFilter("custodian_details", []);
};

export function custodianDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_STATE:
      return {
        ...action.state
      };
    case SET_INNER_DETAILS_STATE:
      state.scrollTop = action.scrollTop;
      return {
        ...getNewInitialState(),
        previousState: state
      };
    case FETCH_CUSTODIAN_DETAILS:
      return {
        ...state,
        details: state.details || null,
        fetchDetailsPending: true,
        fetchDetailsError: null
      };
    case FETCH_CUSTODIAN_DETAILS_SUCCESS:
      let fallbackLinkedSiblingDetails = null;

      try {
        // Just to make sure when applying fallback the current state has a matching sibling details
        if (action.details.info.linkProviderAccountId === state.linkedSiblingDetails.info.linkProviderAccountId) {
          fallbackLinkedSiblingDetails = state.linkedSiblingDetails;
        }
      } catch (e) {}

      return {
        ...state,
        fetchDetailsPending: false,
        details: action.details,
        fetchDetailsError: null,
        linkedSiblingDetails: action.linkedSiblingDetails || fallbackLinkedSiblingDetails
      };
    case GET_CUSTODIAN_CHART:
      return {
        ...state,
        custodianChart: state.custodianChart || null,
        fetchCustodianChartPending: true,
        fetchCustodianChartError: null
      };
    case GET_CUSTODIAN_CHART_SUCCESS:
      return {
        ...state,
        custodianChart: action.chartData,
        fetchCustodianChartPending: false,
        fetchCustodianChartError: null
      };
    case GET_CUSTODIAN_CHART_ERROR:
      return {
        ...state,
        fetchCustodianChartPending: false,
        fetchCustodianChartError: action.error
      };
    case FETCH_CUSTODIAN_DETAILS_HISTORY_SUCCESS:
      return {
        ...state,
        fetchDetailsPending: false,
        details: {
          ...state.details,
          history: action.isCostHistory
            ? state.details.history
            : action.clearPreviousHistory === true
            ? action.history
            : [...state.details.history, ...action.history],
          costHistory: action.isCostHistory
            ? action.clearPreviousHistory === true
              ? action.history
              : [...state.details.costHistory, ...action.history]
            : state.details.costHistory,
          isHistoryLoaded: action.isCostHistory ? state.details.isHistoryLoaded : action.history.length === 0,
          isCostHistoryLoaded: action.isCostHistory ? action.history.length === 0 : state.details.isCostHistoryLoaded
        },
        fetchDetailsError: null
      };
    case FETCH_CUSTODIAN_DETAILS_ERROR:
      return {
        ...state,
        fetchDetailsPending: false,
        details: null,
        fetchDetailsError: action.error
      };
    case UPDATE_CUSTODIAN_DETAILS:
      return {
        ...state,
        details: Object.assign({}, action.updatedDetails)
      };
    case ADD_PENDING_IRR_REQUEST:
      return {
        ...state,
        pendingIrrRequests: [...state.pendingIrrRequests, action.requestId]
      };
    case REMOVE_PENDING_IRR_REQUEST:
      return {
        ...state,
        pendingIrrRequests: state.pendingIrrRequests.filter(
          item => !action.requestId === false && item !== action.requestId
        )
      };
    case DELETE_CUSTODIAN_HISTORY: {
      const newState = { ...state };
      const details = newState.details || {};
      const { history = [] } = details;
      const historyItems = action.isCostHistory ? details.costHistory : history;
      const historyIndex = (historyItems || []).findIndex(entry => entry.id === action.historyId);
      if (historyIndex !== -1) {
        historyItems.splice(historyIndex, 1);
      }
      if (!action.isCostHistory) {
        details.history = [...historyItems];
      }
      return newState;
    }
    case UPDATE_CUSTODIAN_HISTORY: {
      const newState = { ...state };
      const details = newState.details || {};
      const { history = [] } = details;
      const historyItems = action.isCostHistory ? details.costHistory : history;
      const historyIndex = (historyItems || []).findIndex(entry => entry.id === action.history.id);
      if (historyIndex !== -1) {
        historyItems[historyIndex] = action.history;
      } else {
        historyItems.push(action.history);
      }
      if (!action.isCostHistory) {
        details.history = [...historyItems];
      }
      return newState;
    }
    case REFRESH_CUSTODIAN_HISTORY:
      return {
        ...state,
        details: {
          ...state.details,
          isHistoryRefreshing: action.isRefreshing
        }
      };

    case UPDATE_CUSTODIAN_CASHFLOW: {
      const newState = { ...state };
      const details = newState.details;

      if (!details === true) {
        return newState;
      }

      if (!details.cashFlow === true) {
        details.cashFlow = [];
      }

      const cashflowIndex = details.cashFlow.findIndex(entry => entry.id === action.cashflow.id);
      if (cashflowIndex !== -1) {
        details.cashFlow[cashflowIndex] = action.cashflow;
      } else {
        details.cashFlow.push(action.cashflow);
      }

      details.cashFlow = [...details.cashFlow];
      return newState;
    }
    case UPDATE_CUSTODIAN_BULK: {
      const newState = { ...state };
      const details = newState.details;

      if (!details === true || !action.custodians === true) {
        return newState;
      }

      for (const custodian of action.custodians) {
        const custodianIndex = details?.holdings?.findIndex(item => item.id === custodian.id) ?? -1;

        if (custodianIndex !== -1) {
          details.holdings[custodianIndex] = {
            ...details.holdings[custodianIndex],
            ...pickProperties(custodian, action.propertiesToUpdate)
          };
        }

        // Keep the open custodian's own info in sync (e.g. a parent account whose
        // total was recomputed after one of its holdings was archived), so the
        // overlay value tracks the store without relying on the tsModified merge.
        if (!details.info === false && details.info.id === custodian.id) {
          const info = {
            ...details.info,
            ...pickProperties(custodian, action.propertiesToUpdate)
          };
          if (isCostBasisIrrTypeWithoutCost(info)) {
            info.irrType = details.info.irrType;
          }
          details.info = info;
        }
      }
      details?.holdings?.sort((a, b) => a.sortKey.localeCompare(b.sortKey));
      details.holdings = [...(details?.holdings ?? [])];
      return newState;
    }
    case DELETE_HOLDING_BULK: {
      const details = state.details;
      if (!details === true || !Array.isArray(details.holdings) || !Array.isArray(action.holdingIds)) {
        return state;
      }
      const idsToRemove = new Set(action.holdingIds);
      const remaining = details.holdings.filter(item => !idsToRemove.has(item.id));
      if (remaining.length === details.holdings.length) {
        return state;
      }
      const removedCount = details.holdings.length - remaining.length;
      const newDetails = { ...details, holdings: remaining };
      if (!newDetails.info === false && typeof newDetails.info.holdingsCount === "number") {
        newDetails.info = {
          ...newDetails.info,
          holdingsCount: Math.max(0, newDetails.info.holdingsCount - removedCount)
        };
      }
      return { ...state, details: newDetails };
    }
    case INSERT_HOLDING_BULK: {
      const details = state.details;
      if (!details === true || !details.info === true || !Array.isArray(action.holdings)) {
        return state;
      }
      // Re-add holdings of the open parent (e.g. undo of a holding archive);
      // ignore anything that isn't a child of this parent or already present.
      const toAdd = action.holdings.filter(
        holding =>
          holding.parentId === details.info.id && !(details.holdings ?? []).some(item => item.id === holding.id)
      );
      if (toAdd.length === 0) {
        return state;
      }
      const holdings = [...(details.holdings ?? []), ...toAdd].sort((a, b) => a.sortKey.localeCompare(b.sortKey));
      const newDetails = { ...details, holdings };
      if (typeof newDetails.info.holdingsCount === "number") {
        newDetails.info = { ...newDetails.info, holdingsCount: newDetails.info.holdingsCount + toAdd.length };
      }
      return { ...state, details: newDetails };
    }
    case DELETE_CUSTODIAN_CASHFLOW: {
      const newState = { ...state };
      const details = newState.details;
      const cashflowIndex = details.cashFlow.findIndex(entry => entry.id === action.cashflowId);
      if (cashflowIndex !== -1) {
        details.cashFlow = [...details.cashFlow];
        details.cashFlow.splice(cashflowIndex, 1);
      }
      return newState;
    }
    case DELETE_FUND_SCHEDULE: {
      const newState = { ...state };
      const details = newState.details || {};
      const fundSchedule = details.fundSchedule || [];
      const itemIndex = (fundSchedule || []).findIndex(entry => entry.id === action.id);
      if (itemIndex !== -1) {
        fundSchedule.splice(itemIndex, 1);
        details.fundSchedule = [...fundSchedule];
      }
      return newState;
    }
    case UPDATE_FUND_SCHEDULE: {
      const newState = { ...state };
      const details = newState.details || {};
      const fundSchedule = details.fundSchedule || [];
      const itemIndex = (fundSchedule || []).findIndex(entry => entry.id === action.fundSchedule.id);
      if (itemIndex !== -1) {
        fundSchedule[itemIndex] = action.fundSchedule;
      } else {
        fundSchedule.push(action.fundSchedule);
      }
      details.fundSchedule = [...fundSchedule];
      return newState;
    }
    case RESET_CUSTODIAN_DETAILS:
      return initialState;
    default:
      return state;
  }
}

export const custodianDetailsIsPendingSelector = state => state.custodian_details.fetchDetailsPending;

export const isCustodianHistoryRefreshingSelector = state => state.custodian_details.details?.isHistoryRefreshing;

export const custodianDetailsErrorSelector = state => state.custodian_details?.fetchDetailsError;

export const custodianDetailsSelector = state => state.custodian_details.details;

export const linkedSiblingCustodianDetailsSelector = state => state.custodian_details.linkedSiblingDetails;

export const custodianChartDataSelector = state => state.custodian_details.custodianChart;

export const custodianChartIsPendingSelector = state => state.custodian_details.fetchCustodianChartPending;

export const previousDetailsStateSelector = state => state.custodian_details.previousState;

export const custodianDetailsScrollTopSelector = state => state.custodian_details.scrollTop;

export const isIrrUpdatingSelector = state => state.custodian_details.pendingIrrRequests.length !== 0;

export const taxOnUnrealizedGainsSelector = state => {
  const custodianDetails = custodianDetailsSelector(state);
  let detailsInfo = custodianDetails && custodianDetails.info;
  const custodian = custodianSelector(state, detailsInfo?.id);
  if (custodian?.tsModified > detailsInfo?.tsModified) {
    detailsInfo = {
      ...detailsInfo,
      ...custodian
    };
  }
  return detailsInfo && detailsInfo.taxDetails ? JSON.parse(detailsInfo.taxDetails) : null;
};

export const getTaxableTypeForCustodian = state => {
  const taxOnUnrealizedGains = taxOnUnrealizedGainsSelector(state);
  return taxOnUnrealizedGains ? taxOnUnrealizedGains.taxableAssetType : custodianTaxTypes.TAXABLE;
};

export const fundScheduleSelector = (state, type) => {
  const custodianDetails = custodianDetailsSelector(state);
  const fundSchedule = custodianDetails && custodianDetails.fundSchedule ? custodianDetails.fundSchedule : null;

  if (!fundSchedule) {
    return [];
  }
  return fundSchedule.filter(item => item.type === type);
};

const MAX_CUSTODIAN_DETAILS_CACHE_AGE = 7 * 24 * 60 * 60 * 1000;
const MAX_CUSTODIAN_DETAILS_CACHE_SIZE = 50;
const CUSTODIAN_DETAILS_CACHE_KEY = "custodian_details_cache";
export const getCustodianDetailsFromCache = custodianId => {
  const cachedData = localStorage.getItem(CUSTODIAN_DETAILS_CACHE_KEY);
  if (!cachedData) {
    return null;
  }
  const cachedDetails = JSON.parse(cachedData);
  const custodianDetails = cachedDetails.find(item => item.id === custodianId);
  if (!custodianDetails) {
    return null;
  }
  const cacheAge = Date.now() - custodianDetails.storedAt;
  if (cacheAge > MAX_CUSTODIAN_DETAILS_CACHE_AGE) {
    return null;
  }
  return custodianDetails;
};

export const removeCustodianDetailsFromCache = custodianId => {
  const cachedData = localStorage.getItem(CUSTODIAN_DETAILS_CACHE_KEY);
  if (!cachedData) {
    return;
  }
  let cachedDetails = JSON.parse(cachedData);
  cachedDetails = cachedDetails.filter(item => item.id !== custodianId);
  localStorage.setItem(CUSTODIAN_DETAILS_CACHE_KEY, JSON.stringify(cachedDetails));
};

export const saveCustodianDetailsToCache = (custodianId, detailsApiData, linkedSiblingDetailsApiData) => {
  const cachedData = localStorage.getItem(CUSTODIAN_DETAILS_CACHE_KEY);
  let cachedDetails = [];
  if (cachedData) {
    cachedDetails = JSON.parse(cachedData);
  }
  const custodianDetails = {
    id: custodianId,
    detailsApiData,
    linkedSiblingDetailsApiData,
    storedAt: Date.now()
  };
  cachedDetails = cachedDetails.filter(item => item.id !== custodianId);
  cachedDetails.unshift(custodianDetails);
  if (cachedDetails.length > MAX_CUSTODIAN_DETAILS_CACHE_SIZE) {
    cachedDetails.pop();
  }
  localStorage.setItem(CUSTODIAN_DETAILS_CACHE_KEY, JSON.stringify(cachedDetails));
};

export const updateCustodianDetailsInCache = (custodianId, latestDetails) => {
  const cachedData = localStorage.getItem(CUSTODIAN_DETAILS_CACHE_KEY);
  let cachedDetails = [];
  if (cachedData) {
    cachedDetails = JSON.parse(cachedData);
  }
  const custodianDetails = cachedDetails.find(item => item.id === custodianId);
  if (!custodianDetails?.detailsApiData) return;
  custodianDetails.detailsApiData.payload = latestDetails;
  custodianDetails.storedAt = Date.now();
  localStorage.setItem(CUSTODIAN_DETAILS_CACHE_KEY, JSON.stringify(cachedDetails));
};

const CUSTODIAN_CHART_CACHE_KEY = "custodian_chart_cache";
export const getCustodianChartDataFromCache = custodianId => {
  const cachedData = localStorage.getItem(CUSTODIAN_CHART_CACHE_KEY);
  if (!cachedData) {
    return null;
  }
  const cachedDetails = JSON.parse(cachedData);
  const custodianChart = cachedDetails.find(item => item.id === custodianId);
  if (!custodianChart) {
    return null;
  }
  const cacheAge = Date.now() - custodianChart.storedAt;
  if (cacheAge > MAX_CUSTODIAN_DETAILS_CACHE_AGE) {
    return null;
  }
  return custodianChart;
};

export const saveCustodianChartDataToCache = (custodianId, chartApiData) => {
  const cachedData = localStorage.getItem(CUSTODIAN_CHART_CACHE_KEY);
  let cachedDetails = [];
  if (cachedData) {
    cachedDetails = JSON.parse(cachedData);
  }
  const custodianChart = {
    id: custodianId,
    chartApiData,
    storedAt: Date.now()
  };
  cachedDetails = cachedDetails.filter(item => item.id !== custodianId);
  cachedDetails.unshift(custodianChart);
  if (cachedDetails.length > MAX_CUSTODIAN_DETAILS_CACHE_SIZE) {
    cachedDetails.pop();
  }
  localStorage.setItem(CUSTODIAN_CHART_CACHE_KEY, JSON.stringify(cachedDetails));
};

export const clearCustodianDetailsCache = () => {
  localStorage.removeItem(CUSTODIAN_DETAILS_CACHE_KEY);
  localStorage.removeItem(CUSTODIAN_CHART_CACHE_KEY);
};
